import styled from 'styled-components';

export type IconProps = {
  /**
   * Icon type to render
   */
  type: string,
  /**
   * Icon size in px
   */
  size?: string | number,
  /**
   * Icon color
   */
  color?: string,
  /**
   * Icon transforms
   */
  transform?: string,
};

export const StyledIcoin = styled.i<IconProps>`
  font-size: ${props => (typeof props.size === 'number' ? `${props.size}px` : props.size)};
  transform: ${props => props.transform};

  ${props => props.color && `
    color: ${props.theme.colors[props.color] || props.color};
  `};
`;
